import { useTranslation } from "react-i18next";

/**
 * AbandonedScreen — 未受検 (abandoned) にされた respondent への案内画面 (ADR-0054 Decision 3)。
 *
 * features/respond の同名コンポーネントとは i18n 名前空間が異なる (contactEdit) ため、
 * feature 間 import を避けて別ファイルとして持つ (ContactEditClosedScreen と同じ作法)。
 */
export function AbandonedScreen() {
  const { t } = useTranslation("contactEdit");
  return (
    <section className="rounded-lg border border-border bg-card p-6 shadow-sm">
      <h1 className="text-base font-semibold">{t("abandoned.title")}</h1>
      <p className="mt-2 text-sm text-muted-foreground">{t("abandoned.description")}</p>
    </section>
  );
}
